/** use [iso-3166-1-aphia-3](https://www.iso.org/obp/ui/#search/code/) */
export enum CountryCodeEnum {
  // 巴西 t('core.country.BRA')
  BRA = 'BRA',
  // 奈及利亞 t('core.country.NGA')
  NGA = 'NGA',
  // 阿根廷 t('core.country.ARG')
  ARG = 'ARG',
  ZWE = 'ZWE',
  ZMB = 'ZMB',
  ZAF = 'ZAF',
  YEM = 'YEM',
  WSM = 'WSM',
  WLF = 'WLF',
  VUT = 'VUT',
  VNM = 'VNM',
  VIR = 'VIR',
  VGB = 'VGB',
  VEN = 'VEN',
  VCT = 'VCT',
  VAT = 'VAT',
  UZB = 'UZB',
  USA = 'USA',
  URY = 'URY',
  UMI = 'UMI',
  UKR = 'UKR',
  UGA = 'UGA',
  TZA = 'TZA',
  TWN = 'TWN',
  TUV = 'TUV',
  TUR = 'TUR',
  TUN = 'TUN',
  TTO = 'TTO',
  TON = 'TON',
  TLS = 'TLS',
  TKM = 'TKM',
  TKL = 'TKL',
  TJK = 'TJK',
  THA = 'THA',
  TGO = 'TGO',
  TCD = 'TCD',
  TCA = 'TCA',
  SYR = 'SYR',
  SYC = 'SYC',
  SXM = 'SXM',
  SWZ = 'SWZ',
  SWE = 'SWE',
  SVN = 'SVN',
  SVK = 'SVK',
  SUR = 'SUR',
  STP = 'STP',
  SSD = 'SSD',
  SRB = 'SRB',
  SPM = 'SPM',
  SOM = 'SOM',
  SMR = 'SMR',
  SLV = 'SLV',
  SLE = 'SLE',
  SLB = 'SLB',
  SJM = 'SJM',
  SHN = 'SHN',
  SGS = 'SGS',
  SGP = 'SGP',
  SEN = 'SEN',
  SDN = 'SDN',
  SAU = 'SAU',
  RWA = 'RWA',
  RUS = 'RUS',
  ROU = 'ROU',
  REU = 'REU',
  QAT = 'QAT',
  PYF = 'PYF',
  PSE = 'PSE',
  PRY = 'PRY',
  PRT = 'PRT',
  PRK = 'PRK',
  PRI = 'PRI',
  POL = 'POL',
  PNG = 'PNG',
  PLW = 'PLW',
  PHL = 'PHL',
  PER = 'PER',
  PCN = 'PCN',
  PAN = 'PAN',
  PAK = 'PAK',
  OMN = 'OMN',
  NZL = 'NZL',
  NRU = 'NRU',
  NPL = 'NPL',
  NOR = 'NOR',
  NLD = 'NLD',
  NIU = 'NIU',
  NIC = 'NIC',
  NFK = 'NFK',
  NER = 'NER',
  NCL = 'NCL',
  NAM = 'NAM',
  MYT = 'MYT',
  MYS = 'MYS',
  MWI = 'MWI',
  MUS = 'MUS',
  MTQ = 'MTQ',
  MSR = 'MSR',
  MRT = 'MRT',
  MOZ = 'MOZ',
  MNP = 'MNP',
  MNG = 'MNG',
  MNE = 'MNE',
  MMR = 'MMR',
  MLT = 'MLT',
  MLI = 'MLI',
  MKD = 'MKD',
  MHL = 'MHL',
  MEX = 'MEX',
  MDV = 'MDV',
  MDG = 'MDG',
  MDA = 'MDA',
  MCO = 'MCO',
  MAR = 'MAR',
  MAF = 'MAF',
  MAC = 'MAC',
  LVA = 'LVA',
  LUX = 'LUX',
  LTU = 'LTU',
  LSO = 'LSO',
  LKA = 'LKA',
  LIE = 'LIE',
  LCA = 'LCA',
  LBY = 'LBY',
  LBR = 'LBR',
  LBN = 'LBN',
  LAO = 'LAO',
  KWT = 'KWT',
  KOR = 'KOR',
  KNA = 'KNA',
  KIR = 'KIR',
  KHM = 'KHM',
  KGZ = 'KGZ',
  KEN = 'KEN',
  KAZ = 'KAZ',
  JPN = 'JPN',
  JOR = 'JOR',
  JEY = 'JEY',
  JAM = 'JAM',
  ITA = 'ITA',
  ISR = 'ISR',
  ISL = 'ISL',
  IRQ = 'IRQ',
  IRN = 'IRN',
  IRL = 'IRL',
  IOT = 'IOT',
  IND = 'IND',
  IMN = 'IMN',
  IDN = 'IDN',
  HUN = 'HUN',
  HTI = 'HTI',
  HRV = 'HRV',
  HND = 'HND',
  HMD = 'HMD',
  HKG = 'HKG',
  GUY = 'GUY',
  GUM = 'GUM',
  GUF = 'GUF',
  GTM = 'GTM',
  GRL = 'GRL',
  GRD = 'GRD',
  GRC = 'GRC',
  GNQ = 'GNQ',
  GNB = 'GNB',
  GMB = 'GMB',
  GLP = 'GLP',
  GIN = 'GIN',
  GIB = 'GIB',
  GHA = 'GHA',
  GGY = 'GGY',
  GEO = 'GEO',
  GBR = 'GBR',
  GAB = 'GAB',
  FSM = 'FSM',
  FRO = 'FRO',
  FRA = 'FRA',
  FLK = 'FLK',
  FJI = 'FJI',
  FIN = 'FIN',
  ETH = 'ETH',
  EST = 'EST',
  ESP = 'ESP',
  ESH = 'ESH',
  ERI = 'ERI',
  EGY = 'EGY',
  ECU = 'ECU',
  DZA = 'DZA',
  DOM = 'DOM',
  DNK = 'DNK',
  DMA = 'DMA',
  DJI = 'DJI',
  DEU = 'DEU',
  CZE = 'CZE',
  CYP = 'CYP',
  CYM = 'CYM',
  CXR = 'CXR',
  CUW = 'CUW',
  CUB = 'CUB',
  CRI = 'CRI',
  CPV = 'CPV',
  COM = 'COM',
  COL = 'COL',
  COK = 'COK',
  COG = 'COG',
  COD = 'COD',
  CMR = 'CMR',
  CIV = 'CIV',
  CHN = 'CHN',
  CHL = 'CHL',
  CHE = 'CHE',
  CCK = 'CCK',
  CAN = 'CAN',
  CAF = 'CAF',
  BWA = 'BWA',
  BVT = 'BVT',
  BTN = 'BTN',
  BRN = 'BRN',
  BRB = 'BRB',
  BOL = 'BOL',
  BMU = 'BMU',
  BLZ = 'BLZ',
  BLR = 'BLR',
  BLM = 'BLM',
  BIH = 'BIH',
  BHS = 'BHS',
  BHR = 'BHR',
  BGR = 'BGR',
  BGD = 'BGD',
  BFA = 'BFA',
  BES = 'BES',
  BEN = 'BEN',
  BEL = 'BEL',
  BDI = 'BDI',
  AZE = 'AZE',
  AUT = 'AUT',
  AUS = 'AUS',
  ATG = 'ATG',
  ATF = 'ATF',
  ATA = 'ATA',
  ASM = 'ASM',
  ARM = 'ARM',
  ARE = 'ARE',
  AND = 'AND',
  ALB = 'ALB',
  ALA = 'ALA',
  AIA = 'AIA',
  AGO = 'AGO',
  AFG = 'AFG',
  ABW = 'ABW'
}
export enum CountryCodeToCurrencyEnum {
  // 巴西 t('core.country.BRA')
  BRA = 'BRL',
  ZAF = 'ZAR',
  MEX = 'MXN',
  NGA = 'NGA',
  ARG = 'ARG',
  ZWE = 'ZWE',
  ZMB = 'ZMB',
  YEM = 'YEM',
  WSM = 'WSM',
  WLF = 'WLF',
  VUT = 'VUT',
  VNM = 'VNM',
  VIR = 'VIR',
  VGB = 'VGB',
  VEN = 'VEN',
  VCT = 'VCT',
  VAT = 'VAT',
  UZB = 'UZB',
  USA = 'USA',
  URY = 'URY',
  UMI = 'UMI',
  UKR = 'UKR',
  UGA = 'UGA',
  TZA = 'TZA',
  TWN = 'TWN',
  TUV = 'TUV',
  TUR = 'TUR',
  TUN = 'TUN',
  TTO = 'TTO',
  TON = 'TON',
  TLS = 'TLS',
  TKM = 'TKM',
  TKL = 'TKL',
  TJK = 'TJK',
  THA = 'THA',
  TGO = 'TGO',
  TCD = 'TCD',
  TCA = 'TCA',
  SYR = 'SYR',
  SYC = 'SYC',
  SXM = 'SXM',
  SWZ = 'SWZ',
  SWE = 'SWE',
  SVN = 'SVN',
  SVK = 'SVK',
  SUR = 'SUR',
  STP = 'STP',
  SSD = 'SSD',
  SRB = 'SRB',
  SPM = 'SPM',
  SOM = 'SOM',
  SMR = 'SMR',
  SLV = 'SLV',
  SLE = 'SLE',
  SLB = 'SLB',
  SJM = 'SJM',
  SHN = 'SHN',
  SGS = 'SGS',
  SGP = 'SGP',
  SEN = 'SEN',
  SDN = 'SDN',
  SAU = 'SAU',
  RWA = 'RWA',
  RUS = 'RUS',
  ROU = 'ROU',
  REU = 'REU',
  QAT = 'QAT',
  PYF = 'PYF',
  PSE = 'PSE',
  PRY = 'PRY',
  PRT = 'PRT',
  PRK = 'PRK',
  PRI = 'PRI',
  POL = 'POL',
  PNG = 'PNG',
  PLW = 'PLW',
  PHL = 'PHL',
  PER = 'PER',
  PCN = 'PCN',
  PAN = 'PAN',
  PAK = 'PAK',
  OMN = 'OMN',
  NZL = 'NZL',
  NRU = 'NRU',
  NPL = 'NPL',
  NOR = 'NOR',
  NLD = 'NLD',
  NIU = 'NIU',
  NIC = 'NIC',
  NFK = 'NFK',
  NER = 'NER',
  NCL = 'NCL',
  NAM = 'NAM',
  MYT = 'MYT',
  MYS = 'MYS',
  MWI = 'MWI',
  MUS = 'MUS',
  MTQ = 'MTQ',
  MSR = 'MSR',
  MRT = 'MRT',
  MOZ = 'MOZ',
  MNP = 'MNP',
  MNG = 'MNG',
  MNE = 'MNE',
  MMR = 'MMR',
  MLT = 'MLT',
  MLI = 'MLI',
  MKD = 'MKD',
  MHL = 'MHL',
  MDV = 'MDV',
  MDG = 'MDG',
  MDA = 'MDA',
  MCO = 'MCO',
  MAR = 'MAR',
  MAF = 'MAF',
  MAC = 'MAC',
  LVA = 'LVA',
  LUX = 'LUX',
  LTU = 'LTU',
  LSO = 'LSO',
  LKA = 'LKA',
  LIE = 'LIE',
  LCA = 'LCA',
  LBY = 'LBY',
  LBR = 'LBR',
  LBN = 'LBN',
  LAO = 'LAO',
  KWT = 'KWT',
  KOR = 'KOR',
  KNA = 'KNA',
  KIR = 'KIR',
  KHM = 'KHM',
  KGZ = 'KGZ',
  KEN = 'KEN',
  KAZ = 'KAZ',
  JPN = 'JPN',
  JOR = 'JOR',
  JEY = 'JEY',
  JAM = 'JAM',
  ITA = 'ITA',
  ISR = 'ISR',
  ISL = 'ISL',
  IRQ = 'IRQ',
  IRN = 'IRN',
  IRL = 'IRL',
  IOT = 'IOT',
  IND = 'IND',
  IMN = 'IMN',
  IDN = 'IDN',
  HUN = 'HUN',
  HTI = 'HTI',
  HRV = 'HRV',
  HND = 'HND',
  HMD = 'HMD',
  HKG = 'HKG',
  GUY = 'GUY',
  GUM = 'GUM',
  GUF = 'GUF',
  GTM = 'GTM',
  GRL = 'GRL',
  GRD = 'GRD',
  GRC = 'GRC',
  GNQ = 'GNQ',
  GNB = 'GNB',
  GMB = 'GMB',
  GLP = 'GLP',
  GIN = 'GIN',
  GIB = 'GIB',
  GHA = 'GHA',
  GGY = 'GGY',
  GEO = 'GEO',
  GBR = 'GBR',
  GAB = 'GAB',
  FSM = 'FSM',
  FRO = 'FRO',
  FRA = 'FRA',
  FLK = 'FLK',
  FJI = 'FJI',
  FIN = 'FIN',
  ETH = 'ETH',
  EST = 'EST',
  ESP = 'ESP',
  ESH = 'ESH',
  ERI = 'ERI',
  EGY = 'EGY',
  ECU = 'ECU',
  DZA = 'DZA',
  DOM = 'DOM',
  DNK = 'DNK',
  DMA = 'DMA',
  DJI = 'DJI',
  DEU = 'DEU',
  CZE = 'CZE',
  CYP = 'CYP',
  CYM = 'CYM',
  CXR = 'CXR',
  CUW = 'CUW',
  CUB = 'CUB',
  CRI = 'CRI',
  CPV = 'CPV',
  COM = 'COM',
  COL = 'COL',
  COK = 'COK',
  COG = 'COG',
  COD = 'COD',
  CMR = 'CMR',
  CIV = 'CIV',
  CHN = 'CHN',
  CHL = 'CHL',
  CHE = 'CHE',
  CCK = 'CCK',
  CAN = 'CAN',
  CAF = 'CAF',
  BWA = 'BWA',
  BVT = 'BVT',
  BTN = 'BTN',
  BRN = 'BRN',
  BRB = 'BRB',
  BOL = 'BOL',
  BMU = 'BMU',
  BLZ = 'BLZ',
  BLR = 'BLR',
  BLM = 'BLM',
  BIH = 'BIH',
  BHS = 'BHS',
  BHR = 'BHR',
  BGR = 'BGR',
  BGD = 'BGD',
  BFA = 'BFA',
  BES = 'BES',
  BEN = 'BEN',
  BEL = 'BEL',
  BDI = 'BDI',
  AZE = 'AZE',
  AUT = 'AUT',
  AUS = 'AUS',
  ATG = 'ATG',
  ATF = 'ATF',
  ATA = 'ATA',
  ASM = 'ASM',
  ARM = 'ARM',
  ARE = 'ARE',
  AND = 'AND',
  ALB = 'ALB',
  ALA = 'ALA',
  AIA = 'AIA',
  AGO = 'AGO',
  AFG = 'AFG',
  ABW = 'ABW'
}